import Vue from 'vue'
import { Fragment } from 'vue-fragment'
import Observer from '~/components/common/Observer'
import CommonSwiper from '~/components/common/CommonSwiper'
import LazyLoader from '~/components/common/LazyLoader'
import Skeleton from '~/components/common/Skeleton'
import InfiniteLoading from '~/components/common/InfiniteLoading'
import Tabs from '~/components/common/Tabs/tabs'
import TabPane from '~/components/common/Tabs/tab-pane'
import VipIcon from '~/components/logic-common/VipIcon'

// 全局注册组件需要支持ssr，否则会出现提示client side vdom 和服务端不同的警告

Vue.component('Fragment', Fragment)
Vue.component('Observer', Observer)
Vue.component('LazyLoader', LazyLoader)
Vue.component('Skeleton', Skeleton)
Vue.component('CommonSwiper', CommonSwiper)
Vue.component('InfiniteLoading', InfiniteLoading)
Vue.component('Tabs', Tabs)
Vue.component('TabPane', TabPane)
Vue.component('VipIcon', VipIcon)
